module.exports = __webpack_public_path__ + "img/vinil-dublu-madrigal-de-craciun.a936ca40.jpg";